import hasPermit from './permission/hasPermit'

const install = function(Vue) {
  Vue.directive('hasPermit', hasPermit)
}

if (window.Vue) {
  window['hasPermit'] = hasPermit
  Vue.use(install); // eslint-disable-line
}

export default install
